// extracted by mini-css-extract-plugin
export default {"signatureField":"WYO2Pc","header":"oaVPYZ","inputContainer":"y_Qzc1"};